import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import SpaDetails from './pages/SpaDetails';
import Neighborhoods from './pages/Neighborhoods';
import Deals from './pages/Deals';

function App() {
  return (
    <HashRouter>
      <div className="flex flex-col min-h-screen font-sans">
        <Navbar />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/neighborhoods" element={<Neighborhoods />} />
            <Route path="/deals" element={<Deals />} />
            <Route path="/spa/:id" element={<SpaDetails />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </HashRouter>
  );
}

export default App;